import { useMemo } from 'react';
import DocumentTitle from 'react-document-title';

import { Loader } from '@hivebrite/design-system/Loader';

import { MentorshipsContextProvider } from 'hb-react/frontoffice/apps/Mentorships/contexts/MentorshipsContext';
import { useConfig } from 'hb-react/frontoffice/apps/Mentorships/hooks/useConfig';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { getPageTitle } from 'hb-react/frontoffice/utils/page';
import { useMenuName } from 'hb-react/shared/hooks/useMenuName';

import MentorshipsIndexContainer from '../containers/MentorshipsIndexContainer';
import {
  getMentorLabel,
  getMenteeLabel,
  getMentorApplicationFormText,
  getMenteeApplicationFormText,
  getMentorApplicationConfig,
} from '../utils';

// TODO: all folder to be removed, when removing flag flag-ev-mentoring-multiple-mentor-programs

const MentorshipsApp = ({ routes, topic }) => {
  const { currentNetwork } = useDefaultAppContexts();
  const { appPages, config } = useConfig({ routes, topic });

  const mentorApplicationConfig = useMemo(
    () => getMentorApplicationConfig(currentNetwork, topic),
    [currentNetwork, topic],
  );

  const menuName = useMenuName('mentorships', s__('Mentorships|Mentoring'));

  if (!appPages) {
    return <Loader full />;
  }

  return (
    <>
      <DocumentTitle title={getPageTitle({ featureName: 'mentorships' })} />
      <MentorshipsContextProvider
        owner={{
          id: topic?.id || currentNetwork.id,
          type: topic ? 'Topics::Topic' : 'Network',
          name: topic?.name || currentNetwork.title,
        }}
        menuName={menuName}
        mentorLabel={getMentorLabel(currentNetwork, topic)}
        menteeLabel={getMenteeLabel(currentNetwork, topic)}
        mentorApplicationFormText={getMentorApplicationFormText(
          currentNetwork,
          topic,
        )}
        menteeApplicationFormText={getMenteeApplicationFormText(
          currentNetwork,
          topic,
        )}
        mentorApplicationConfig={mentorApplicationConfig}
      >
        <MentorshipsIndexContainer config={config} />
      </MentorshipsContextProvider>
    </>
  );
};

export default MentorshipsApp;

MentorshipsApp.defaultProps = {
  routes: {
    fetchMentors: Routes.mentorships_mentors_path(),
  },
  topic: null,
};
